module.exports = {"id":"156432","name":"Guillaume Hoarau","rating":"77","photo":"./data/images/photos/2/156432.png","club":{"name":"BSC Young Boys","logo":"./data/images/clubs/BSCYoungBoys.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GuillaumeHoarau0.json
// module id = 1656
// module chunks = 0